<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >{{ classData.title }}
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <template v-if="classStatus !== 'done'">
        <class-info-form
          v-if="classData.id"
          :classData="classData"
          ref="form"
          @save="save"
        ></class-info-form>
        <v-row class="pr-6 pb-6 mt-n7" no-gutters>
          <v-spacer></v-spacer>
          <v-btn class="px-6" depressed color="primary" :loading="loading" @click="save">Lưu</v-btn>
        </v-row>
      </template>
      <v-card-text v-else>
        <p class="text-h6 mb-0 text-center pt-2">Lớp học đã kết thúc</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ClassInfoForm from '@/components/basic/form/ClassInfoForm'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ClassInfoForm
  },
  props: {
    state: Boolean,
    classData: Object,
    slots: Array
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user']),
    classStatus() {
      return this.classData.status
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateSlots', 'updateClass']),
    async save() {
      const data = this.$refs.form.getData()
      if (!data) {
        return
      }
      const next = (async () => {
        this.loading = true
        await this.updateClass({ id: this.classData.id, ...data })
        this.dialog = false
        const upcomingSlots = this.slots.filter(slot => slot.startTime >= moment().toISOString())
        await this.updateSlots(
          upcomingSlots.map(slot => ({
            id: slot.id,
            room: data.room
          }))
        )
        this.loading = false
        this.$alert.success('Cập nhật thành công!')
      }).bind(this)

      if (this.classStatus === 'running') {
        this.$dialog.confirm({
          title: 'Xác Nhận thay đổi',
          text: `Lớp học đang diễn ra, thay đổi thiết lập có thể xóa vĩnh viễn những dữ liệu không phù hợp với thiết lập mới. Bạn có chắc chắn muốn tiếp tục?`,
          okText: 'Xác nhận',
          cancelText: 'Hủy',
          done: async () => {
            await next()
          }
        })
      } else {
        await next()
      }
    },
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
